document.addEventListener('rebuy:smartcart.init', (event) => {
    console.log('rebuy:smartcart.init event', event.detail);
    const RebuyCart = window.Rebuy.Cart;
    const SmartCart = window.Rebuy.SmartCart;
});

document.addEventListener('rebuy:smartcart.ready', (event) => {
    const smartcart = event.detail.smartcart;
    console.log('rebuy:smartcart.ready: smartcart', smartcart);

    console.log(window.Rebuy.SmartCart.initialized)
    console.log(document.querySelector('#rebuy-smartcart'))
    console.log(window.Rebuy.widgets)
    
    const RebuyCartTrigger = document.querySelectorAll('.header-toggle-cart')
    console.log(RebuyCartTrigger)

    // document.addEventListener('rebuy:cart.add', (event) => { 
    //     console.log('rebuy:cart.add event', event.detail); 
    //     SmartCart.show()
    // });

    if(RebuyCartTrigger.length >= 1) {
        RebuyCartTrigger.forEach(element => {
            element.addEventListener('click', (event) => {
                const SmartCart = window.Rebuy.SmartCart;
                console.log(event)
                SmartCart.show()
            });
        });
    }
});
